import { FC } from 'react';

import { LobsTab } from './lobs/lobs-tab';
import { LocationsTab } from './locations/locations-tab';
import { LookupsTab } from './lookups/lookups-tab';
import { ProvidersTab } from './providers/providers-tab';
import { InsuranceCarriersTab } from './insurance-carriers/insurance-carriers-tab';
import { LocationStatesTab } from './location-states/location-states-tab';

export const tabConfig: Record<
	string,
	{
		label: string;
		component: FC<TabProps>;
	}
> = {
	lobs: {
		label: 'Line of Businesses',
		component: LobsTab,
	},
	locations: {
		label: 'Locations',
		component: LocationsTab,
	},
	lookups: {
		label: 'Lookups',
		component: LookupsTab,
	},
	providers: {
		label: 'Providers',
		component: ProvidersTab,
	},
	insuranceCarriers: {
		label: 'Insurance Carriers',
		component: InsuranceCarriersTab,
	},
	locationStates: {
		label: 'Location States',
		component: LocationStatesTab,
	},
};

export interface TabProps {
	importTypeId: number;
	importTypeName: string;
}
